export default "__VITE_ASSET__DOaQ0_zT__"